<template>
  <div>
    <AddReviews
      :showAddReviews="showAddReviews"
      @close="showAddReviews = false"
    ></AddReviews>
    <div class="bg-white m-3 rounded-md">
      <div
        class="border-b-0.5 flex flex-wrap lg:gap-0 gap-4 justify-between items-center p-3"
      >
        <div class="flex gap-4">
          <input
            v-if="selectedTab == 'Goals'"
            type="text"
            placeholder="Search Objectives"
            class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
          />

          <input
            type="text"
            onfocus="(this.type='date')"
            onbur="(this.type='text')"
            placeholder="Due Date"
            class="rounded-xl w-full pl-4 py-3 bg-gray-200 text-sm"
          />
          <input
            type="text"
            placeholder="Filter By"
            class="rounded-xl w-full pl-4 py-1 bg-gray-200 text-sm"
          />
        </div>
        <button
          @click="showAddReviews = true"
          v-if="selectedTab == 'Goals'"
          class="bg-primary text-white rounded-full px-3 py-3 text-sm"
        >
          Add Objectives
        </button>
      </div>
      <Goals :key="gKey" v-if="selectedTab == 'Goals'"></Goals>
      <Compentencies
        :key="cKey"
        v-if="selectedTab == 'Compentencies'"
      ></Compentencies>
    </div>
  </div>
</template>

<script>
import Goals from "./goals.vue";
import Compentencies from "./compentencies.vue";
import AddReviews from "./addreviews.vue";
export default {
  name: "MyReviewsHome",
  components: { Goals, Compentencies, AddReviews },
  data() {
    return {
      selectedTab: "Goals",
      showAddReviews: false,
      gKey: 0,
      cKey: 1,
      tabs: ["Goals", "Compentencies"],
    };
  },
  methods: {
    changeTab(tab) {
      this.selectedTab = tab;
      switch (this.selectedTab) {
        case "Goals":
          this.gKey++;
          break;
        case "Compentencies":
          this.cKey++;
          break;
      }
    },
  },
};
</script>
